import { Component } from '@angular/core';

@Component({
  selector: 'adminapp-summary-functional-description',
  templateUrl: './summary-functional-description.component.html',
  styleUrls: ['./summary-functional-description.component.scss']
})
export class SummaryFunctionalDescriptionComponent {

  constructor() { }
}
